module.exports = __webpack_public_path__ + "static/media/imagem34.b93e0eb8.jpeg";